import { Component, OnInit } from '@angular/core';
import { AccessaryService } from 'src/app/shared/services/accessary.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Accessory } from '../accessory-cat/accessory-cat.model';

@Component({
    selector: 'app-accessory-detail',
    templateUrl: './accessory-detail.component.html',
    styleUrls: ['./accessory-detail.component.scss']
})
export class AccessoryDetailComponent implements OnInit {
    url: string;
    accessory: Accessory['data'];
    relatedDevice: Accessory;
    customOptions: any = {
        autoplay: true,
        mouseDrag: true,
        touchDrag: true,
        pullDrag: false,
        fade: true,
        cssEase: 'linear',
        items: 1
    };
    constructor(private AccessaryService: AccessaryService, private route: ActivatedRoute, private router: Router) {
        this.route.params.subscribe(Response => {
            this.url = Response.url;
            // console.log(this.url);

            this.router.routeReuseStrategy.shouldReuseRoute = function() {
                return false;
            };
        });
    }

    back() {
        window.history.back();
    }

    ngOnInit() {
        this.AccessaryService.getDetail(this.url).subscribe((res: Accessory['data']) => {
            this.accessory = res;

            this.AccessaryService.getRelated(this.accessory.brand, this.accessory.accessoryType).subscribe(
                (res: Accessory) => {
                    this.relatedDevice = res;
                    // console.log(res);
                }
            );
        });
    }
}
